/**
 * MegaNav — standalone desktop mega menu (Serapian)
 * Hover open/close with 150ms debounce (Lisa Corti pattern).
 * Does not touch legacy MenuMobile / custom.js menu handlers.
 */
(function () {
  'use strict';

  var CLOSE_DELAY_MS = 150;
  var DESKTOP_MIN = 1025;
  var closeTimeout = null;
  var nav = null;
  var backdrop = null;
  var headerEl = null;
  var headerBar = null;
  var bound = false;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN && !document.documentElement.classList.contains('tablet');
  }

  function setMegaNavOpenState(isOpen) {
    if (headerEl) headerEl.classList.toggle('is-mega-nav-open', isOpen);
    if (headerBar) headerBar.classList.toggle('Header--is-active-visible', isOpen);
    if (backdrop) backdrop.classList.toggle('is-visible', isOpen);
  }

  function cancelScheduledClose() {
    if (closeTimeout !== null) {
      window.clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  }

  function scheduleClose() {
    cancelScheduledClose();
    closeTimeout = window.setTimeout(function () {
      closeAll();
    }, CLOSE_DELAY_MS);
  }

  function positionPanel(dropdown) {
    if (!headerEl || !dropdown) return;
    var top = Math.round(headerEl.getBoundingClientRect().bottom);
    dropdown.style.top = top + 'px';
    dropdown.style.setProperty('--mega-nav-top', top + 'px');
    if (backdrop) {
      backdrop.style.top = top + 'px';
    }
  }

  function setBridgeHeight(item, dropdown) {
    if (!item || !dropdown) return;
    var itemRect = item.getBoundingClientRect();
    var panelTop = headerEl ? headerEl.getBoundingClientRect().bottom : itemRect.bottom;
    var gap = Math.max(0, panelTop - itemRect.bottom);
    item.style.setProperty('--mega-nav-bridge', gap + 4 + 'px');
  }

  function closeAll() {
    if (!nav) return;

    nav.querySelectorAll('.MegaNav__Dropdown.is-visible').forEach(function (dropdown) {
      dropdown.classList.remove('is-visible');
      dropdown.setAttribute('aria-hidden', 'true');
    });
    nav.querySelectorAll('.MegaNav__Item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      item.style.removeProperty('--mega-nav-bridge');
    });
    nav.classList.remove('is-open');

    setMegaNavOpenState(false);
  }

  function openItem(item) {
    var dropdown = item.querySelector('.MegaNav__Dropdown');
    if (!dropdown || !nav) return;

    closeAll();
    positionPanel(dropdown);
    setBridgeHeight(item, dropdown);

    item.classList.add('is-open');
    dropdown.classList.add('is-visible');
    dropdown.setAttribute('aria-hidden', 'false');
    nav.classList.add('is-open');

    setMegaNavOpenState(true);
  }

  function onItemEnter(event) {
    if (!isDesktop()) return;
    var item = event.currentTarget;
    if (!item.classList.contains('MegaNav__Item--has-dropdown')) return;
    cancelScheduledClose();
    openItem(item);
  }

  function onItemLeave(event) {
    if (!isDesktop()) return;
    var item = event.currentTarget;
    var dropdown = item.querySelector('.MegaNav__Dropdown');
    var related = event.relatedTarget;
    if (related && (item.contains(related) || (dropdown && dropdown.contains(related)))) {
      return;
    }
    scheduleClose();
  }

  function onDropdownEnter() {
    cancelScheduledClose();
  }

  function onDropdownLeave(event) {
    var related = event.relatedTarget;
    if (related && nav && nav.contains(related)) return;
    scheduleClose();
  }

  function onNavLeave() {
    scheduleClose();
  }

  function onBackdropClick() {
    closeAll();
  }

  function onKeyUp(event) {
    if (event.key === 'Escape' || event.which === 27) {
      closeAll();
    }
  }

  function onScrollOrResize() {
    if (!isDesktop()) {
      closeAll();
      return;
    }
    if (!bound) bind();
    var openDropdown = nav && nav.querySelector('.MegaNav__Dropdown.is-visible');
    if (openDropdown) {
      positionPanel(openDropdown);
      var openItemEl = openDropdown.closest('.MegaNav__Item');
      if (openItemEl) setBridgeHeight(openItemEl, openDropdown);
    }
  }

  function bind() {
    if (!nav || bound) return;
    bound = true;

    nav.querySelectorAll('.MegaNav__Item--has-dropdown').forEach(function (item) {
      item.addEventListener('mouseenter', onItemEnter);
      item.addEventListener('mouseleave', onItemLeave);

      var dropdown = item.querySelector('.MegaNav__Dropdown');
      if (dropdown) {
        dropdown.addEventListener('mouseenter', onDropdownEnter);
        dropdown.addEventListener('mouseleave', onDropdownLeave);
      }
    });

    nav.addEventListener('mouseleave', onNavLeave);
    if (backdrop) backdrop.addEventListener('click', onBackdropClick);
    document.addEventListener('keyup', onKeyUp);
  }

  function init() {
    nav = document.querySelector('[data-mega-nav]');
    if (!nav) return;

    backdrop = document.querySelector('[data-mega-nav-backdrop]');
    headerEl =
      document.querySelector('#shopify-section-header') ||
      document.querySelector('#section-header') ||
      document.querySelector('.Header');
    headerBar = document.querySelector('.Header') || document.querySelector('#section-header');

    // Keep backdrop outside header stacking contexts so it never covers the panel
    if (backdrop && backdrop.parentElement !== document.body) {
      document.body.appendChild(backdrop);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    if (!isDesktop()) return;
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
